import { ScrapbookFile } from '@/api/scrapbook-data';
import ContentPreviewWraper from './ContentPreviewWraper';

import React from 'react';

interface AISummaryPreviewProps {
  content: ScrapbookFile | null;
  onClose: () => void;
}
const AISummaryPreview = ({ content, onClose }: AISummaryPreviewProps) => {
  if (!content) return null;

  const onCopy = async () => {
    if (!content) return;

    const textToCopy = content.content.response;

    await navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([textToCopy.replace(/\n/g, '<br/>')], { type: 'text/html' }),
        'text/plain': new Blob([textToCopy], { type: 'text/plain' }),
      }),
    ]);
  };

  return (
    <ContentPreviewWraper
      content={content}
      onClose={onClose}
      title="AI Summary"
      subTitle={content?.content?.pageTitle}
      onCopy={onCopy}
    >
      <div className="summary-text my-5 text-left text-base leading-relaxed whitespace-pre-wrap text-gray-800">
        {content.content.response}
      </div>
    </ContentPreviewWraper>
  );
};

export default AISummaryPreview;
